import { render, staticRenderFns } from "./StatisticsTotalCosts.vue?vue&type=template&id=4ed18440&"
import script from "./StatisticsTotalCosts.vue?vue&type=script&lang=js&"
export * from "./StatisticsTotalCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports